<template>
  <basic-container>
    <el-form :model="searchForm" ref="searchFormRef" label-width="100px" v-show="searchBoxFlag">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="医院名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width:100%"
              placeholder="请选择"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目编号" prop="code">
            <el-input
              clearable
              v-model="searchForm.code"
              placeholder="项目编号"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="项目名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="项目名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目年度" prop="annual" style="width:100%">
            <el-date-picker clearable v-model="searchForm.annual" type="year" placeholder="项目年度" value-format="yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目节点" prop="progressStage">
            <el-select clearable v-model="searchForm.progressStage" style="width:100%" placeholder="项目节点">
              <el-option
                v-for="item in progressStageList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目负责人" prop="chargeUserId">
            <el-select clearable v-model="searchForm.chargeUserId" style="width:100%" placeholder="项目负责人">
              <el-option
                v-for="item in chargeUserList"
                :key="item.chargeUserId"
                :label="item.chargeUserName"
                :value="item.chargeUserId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="立项方式" prop="startupWay">
            <el-select clearable v-model="searchForm.startupWay" style="width:100%" placeholder="立项方式">
              <el-option
                v-for="item in startupWayList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="立项日期" prop="startupDate">
            <el-date-picker
              style="width: 100%"
              clearable
              v-model="searchForm.timeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预算金额" prop="startupDate">
            <div style="display:flex;">
              <moneyInput1 placeholder="预算金额" v-model="searchForm.lowBudgetAmount">

              </moneyInput1>
              -
              <moneyInput1 placeholder="预算金额" v-model="searchForm.highBudgetAmount">

              </moneyInput1>
             
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目进度" prop="executeStatus">
            <el-select v-model="searchForm.executeStatus" style="width:100%" placeholder="项目进度">
              <el-option
                v-for="item in executeStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <div style="float:right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
     <template slot="budgetAmount" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.budgetAmount,4)  }}</span></div>
            </template>
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
          新 增</el-button
        >
        <exportData :moduleType="400" @exportExcel="exportExcel"></exportData>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          @click="importengineeForm"
          
        >导入
        </el-button>
        <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="delConstractInvoice">删除</el-button> -->
      </template>
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot-scope="scope" slot="executeStatus">
        <el-tag :type="scope.row.executeStatus=='0'?'success':'danger'">{{executeStatusLable(scope.row.executeStatus)}}</el-tag>
        
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-tickets"
          @click="checkRecord(scope.row)"
          >查看
        </el-button>
        <el-button type="text" size="small" icon="el-icon-edit" @click="editRecord(scope.row)"
          >编辑
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="removeRecord(scope.row)"
          >删除
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="editPlan(scope.row)"
          >编制计划
        </el-button>
      </template>
    </avue-crud>
    <el-drawer
      title="编制计划"
      :visible.sync="drawerVisible"
      direction="rtl"
     append-to-body
     modal-append-to-body
      :before-close="drawerClose">
      <el-form :model="planForm" ref="formRef" :rules='formRules' label-width="120px">
            <el-row :gutter="24">
              

              <!-- 招议标信息 -->
            
              <el-col :span="24">
                <el-form-item label="招标文件上传" prop="bidFileUploadDate	">
                  <el-date-picker
                    v-model="planForm.bidFileUploadDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="招标审批完成" prop="bidApproveFinishDate">
                  <el-date-picker
                    v-model="planForm.bidApproveFinishDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="开标/议标日期" prop="bidOpenDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.bidOpenDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="商务谈判日期" prop="businessNegotiationDate">
                  <el-date-picker
                    v-model="planForm.businessNegotiationDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="中标通知日期" prop="bidWinningNoticeDate">
                  <el-date-picker
                    v-model="planForm.bidWinningNoticeDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
             

              <!-- 合同信息 -->
              
              <el-col :span="24">
                <el-form-item label="合同会签日期" prop="contractCountersignDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.contractCountersignDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              
              <el-col :span="24">
                <el-form-item label="合同签订日期" prop="contractSignDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.contractSignDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
     
              <el-col :span="24">
                <el-form-item label="开工日期" prop="workStartDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.workStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="竣工日期" prop="workFinishDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.workFinishDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="结算资料送审" prop="settlementDataSubmitDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.settlementDataSubmitDate"  value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="审计报告" prop="auditReportDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.auditReportDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="质保金支付" prop="qualityGuaranteePayDate">
                  <el-date-picker :disabled="operatorModel=='view'" v-model="planForm.qualityGuaranteePayDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item >
                  <div style="text-algin:center;margin-right:24px;">
                            <el-button type="primary" icon='el-icon-circle-check' @click="submitPlan" style="margin-right: 20px"  >保存</el-button>
                            <el-button icon="el-icon-circle-close" @click="canclePlan">取消</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
    </el-drawer>
    <engineerRecord
      v-if="visible"
      :visible.sync="visible"
      :operatorModel="operator"
      :title="title"
      :rowData="rowData"
      :form.sync="form"
      @afterSubmit='afterSubmit'
    ></engineerRecord>

     <el-dialog
      title="设备设施信息数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      :close-on-click-modal="false"
      width="555px"
      accept="vnd.ms-excel"
    >
      <avue-form v-if="showUploadDialog" :option="excelOption" ref="excelform" v-model="upload" :upload-after="uploadAfter"
                 :before-upload="beforeUpload">

        <template slot-scope="scope" slot="downloadAction">    
            模板下载:
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            
            @click="exportDemoExcel"
          >下载模板
          </el-button>
            <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>
  </basic-container>
</template>
<script>
 import {getToken} from '@/util/auth';
import { getProjectList } from '@/api/crmedical/project/project';
import searchFromShow from '@/components/search-form-show/index';
import engineerRecord from './engineerRecord.vue';
import { getDictionary } from '@/api/common';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary'; //项目字典
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getChargeMan,
  getEditPlan,
  editPlan
} from '@/api/v4ward/engineering/engineering';
import moneyInput1 from '@/components/money-input/index2.vue';
// 自定义数据导出组件
import exportData from "@/components/exportData/exportDataSimple";
export default {
  components: { searchFromShow, engineerRecord ,moneyInput1,exportData},
  data() {
    return {
      upload:{},
      showUploadDialog:false,
      drawerVisible:false,
      title: '新增',
      planForm:{
        bidFileUploadDate:'',
        bidApproveFinishDate:'',
        bidOpenDate:'',
        businessNegotiationDate:'',
        bidWinningNoticeDate:'',
        contractCountersignDate:'',
        contractSignDate:'',
        workStartDate:'',
        workFinishDate:'',
        settlementDataSubmitDate:'',
        auditReportDate:'',
        qualityGuaranteePayDate:''
      },
      form: {
        projectId:'',
        engineeringPlan:{},
        code:'',
        name:'',
        annual:'',
        progressStage:'',
        chargeUserId:'',
        chargeUserName:'',
        startupWay:'',
        startupDate:'',
        budgetAmount:'',
        bidFileUploadDate:'',
        bidApproveFinishDate:'',
        bidOpenDate:'',
        businessNegotiationDate:'',
        bidWinningNoticeDate:'',
        partnerId:'',
        contractCountersignDate:'',
        contractAmount:'',
        contractSignDate:'',
        contractLimitDay:'',
        workChargeName:'',
        workChargeTel:'',
        workStartDate:'',
        workFinishDate:'',
        settlementDataSubmitDate:'',
        auditReportDate:'',
        auditAmount:'',
        prepayAmount:'',
        progressAmount:'',
        qualityGuaranteeAmount:'',
        qualityGuaranteePayDate:'',
        remark:'',
        fileAttach:[],
        executeStatus:''
      },
      operator: 'add',
      searchHeight: '',
      visible: false, //对话框
      searchBoxFlag: true,
      progressStageList: [], //项目节点
      chargeUserList: [], //项目负责人
      startupWayList: [], //立项方式
      executeStatusList: [], //项目进度
      searchForm: {
        projectId: '',
        code: '',
        annual: '',
        name: '',
        progressStage: '',
        chargeUserId: '',
        startupWay: '',
        executeStatus: '',
        timeRange: [],
        endDate:'',
        startDate:'',
        highBudgetAmount:'',
        lowBudgetAmount:''
      },
      data: [],
      option: {
        selection: true,
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '医院名称',
            prop: 'projectName',
          },

          {
            label: '项目编号',
            prop: 'code',
          },
          {
            label: '项目名称',
            prop: 'name',
          },

          {
            label: '项目年度',
            prop: 'annual',
          },
          {
            label: '项目节点',
            prop: 'progressStageName',
          },
          {
            label: '项目负责人',
            prop: 'chargeUserName',
          },
          {
            label: '立项方式',
            prop: 'startupWayName',
          },
          {
            label: '立项日期',
            prop: 'startupDate',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '预算金额（万）',
            prop: 'budgetAmount',
            align:'right',
          
            slot:true
          },
          {
            label: '项目进度',
            prop: 'executeStatus',
            slot:true
            
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      rowData:{},
       excelOption: {
          submitBtn: false,
          emptyBtn: false,
          column: [
            {
              label: '数据上传',
              prop: 'excelFile',
              type: 'upload',
              drag: true,
              loadText: '数据上传中，请稍等',
              span: 24,
              propsHttp: {
                res: 'data',
              },
              tip: '请上传 .xls,.xlsx 标准格式文件',
              action: '/api/v4ward/engineering/uploadExcelEngineering',
            },

          {
            label: '模板下载',
            prop:'downloadAction',
            formslot:true,
          }
          ],
        },
        contractIds:[],
        exportForm:{
          projectId:''
        }
    };
  },
  created() {
    
  },
  mounted() {
    this.calcHeight();
  },
  watch:{
    '$route.path':function(newVal,oldVal){
          // console.log(newVal + '---' +  oldVal);
          if(newVal === '/crmedical/engineering/engineeringManagement'){
             this.$refs.crud.$refs.table.doLayout()
          }
        }
  },
  methods: {
    canclePlan(){
      this.drawerVisible = false
    },
    selectionChange(val){
      this.contractIds = []
      val.forEach(element => {
        this.contractIds.push(element.id)
      });
    },
    exportExcel(data) {

        let saveIds = data.exportExcelSelectionRadio=='1'?'':this.contractIds;
      
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
        this.$confirm("是否导出工程管理数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
            let projectId =this.exportForm.projectId ?this.exportForm.projectId:this.searchForm.projectId;

            if(data.exportExcelSelectionRadio == 2){
              this.tool.downloadFile(`/api/v4ward/engineering/engineeringExport?${
                  this.website.tokenHeader
                }=${getToken()}&projectId=${projectId}&ids=${saveIds}`)
              
            }else{
              // 将条件参数拼接为路由传参格式
             
              // 
              this.tool.downloadFile(
                `/api/v4ward/engineering/engineeringExport?${
                  this.website.tokenHeader
                }=${getToken()}&projectId=${projectId}&ids=`,"abc.xlsx",'xlsx/xls'
                )
             
            }

          });
      },
    importengineeForm(){
      this.showUploadDialog = true  
      setTimeout(()=>{

          console.log(this.$refs.excelform);
          this.$refs.excelform.form.excelFile = [];
        })
    },
    exportDemoExcel() {
        this.$confirm("是否导出模板数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出设备设施模版
          window.open(`/api/v4ward/engineering/export-templateEngineering?${this.website.tokenHeader}=${getToken()}&projectId=` + this.searchForm.projectId);

        });
      },
       uploadAfter(res,done){
        done();
        if(this.vdui.isEmpty(String(res))){
          this.$message.success('导入成功！');
          this.showUploadDialog = false;
          this.onLoad();
        }
      },
   
    afterSubmit(){
      this.onLoad()
    },
    searchClear(){
      this.tool.clearObject(this.searchForm,'projectId')
      this.page.pageSize = 10
      this.page.pageSize = 1
      console.log(this.searchForm)
    },
    executeStatusLable(value){
      
      if(value ==1){
        return "延期"
      }else{
        return "正常"
      }
      
    },
    submitPlan(){
      editPlan(this.planForm).then(res=>{
        this.$message.success('操作成功!');
      })
    },
    editPlan(row){
      getEditPlan({engineeringId:row.id}).then(
        res=>{
          this.planForm = res.data
           this.drawerVisible = true
        }
      )
     
    },
    removeRecord(row){
      this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
    },
    editRecord(row){
       this.operator = 'update';
        this.title = "编辑"
        getDetail({
          id:row.id
        }).then(res=>{
          this.form = res.data
          this.form.progressStage+=''
          this.form.startupWay+=''
          this.visible = true;
        })
    },
    checkRecord(row){
      this.operator = 'view';
      this.title = "查看"
      getDetail({
        id:row.id
      }).then(res=>{
        this.form = res.data
        this.form.progressStage+=''
        this.form.startupWay+=''
        this.visible = true;
      })
      // this.rowData = row
      // this.visible = true;
    },
    searchRecord(){
      this.exportForm = Object.assign({},this.searchForm)
      if(this.searchForm.lowBudgetAmount>this.searchForm.highBudgetAmount){
              //大金额在后面
              let transfromNum = this.searchForm.highBudgetAmount
              this.searchForm.highBudgetAmount = this.searchForm.lowBudgetAmount
              this.searchForm.lowBudgetAmount = transfromNum
            }
            console.log(this.searchForm.timeRange)
            if(this.searchForm.timeRange&&this.searchForm.timeRange.length>0){
                this.searchForm.startDate = this.dayjs(this.searchForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.searchForm.endDate = this.dayjs(this.searchForm.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
            }else{
                this.searchForm.timeRange = []
                this.searchForm.startDate = ''
                  this.searchForm.endDate = ''
            }
      this.onLoad()
    },
    addRecord() {
      this.tool.clearObject(this.form)
      this.form.projectId = this.searchForm.projectId
      this.operator = 'add';
      this.title = "新增"
      this.visible = true;
      
    },
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279;
    },
    projectIdChange() {
      if(this.searchForm.projectId){
        this.tool.clearObject(this.searchForm,'projectId')
        this.initDic(this.searchForm.projectId);
      }
    },
    initData() {
      this.getExecuteStatusList()
      getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.searchForm, 'projectId', this.projectList[0].id);
          this.initDic(this.searchForm.projectId);
          this.onLoad()
        }
      });
    },
    initDic(id) {
      this.getStartupWayList(id);
      this.getProgressStageList(id);
      this.getChargeUseList(id);
    },
    getStartupWayList(projectId) {
      //立项方式
      getProjectDict({
        code: 'engineering_startup_way',
        projectId: projectId,
      }).then((res) => {
        this.startupWayList = res.data;
      });
    },
    //工程项目节点
    getProgressStageList(projectId) {
      getProjectDict({
        code: 'engineering_progress_stage',
        projectId: projectId,
      }).then((res) => {
        this.progressStageList = res.data;
      });
    },
    //负责人
    getChargeUseList(projectId) {
      getChargeMan({
        projectId: projectId,
      }).then((res) => {
        this.chargeUserList = res.data;
      });
    },
    //项目进度
    getExecuteStatusList(){
      getDictionary(
        'engineering_execute_status'
      ).then(res=>{
        this.executeStatusList = res.data
      })
    },
    onLoad() {
       this.loading = true;
            if(this.searchForm.projectId){
              getList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.searchForm)).then(({data})=>{
                this.data = data.records
                this.page.total = data.total
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            })
            }else{
              this.initData();
             
            }
    },
  },
};
</script>
<style scoped>
::v-deep  .el-drawer__body{
  overflow-y: auto
}
.executeStatus{
  width: 32px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
  .money{
  text-align: right;
}
</style>

